<template>
  <div class="reg_box">
    <div class="reg_title">新用户注册</div>
    <div class="reg_row"><span class="reg_left">手机号：</span><span><input type="text" v-model="phoneNum" maxlength="11"></span></div>
    <div class="reg_row"><span class="reg_left">验证码：</span><span><input type="text" maxlength="5"  v-model="captcha"></span><span class="getCode" @click="toSendMsg" v-if="countDown == 120">获取验证码</span><span class="getCode count_down" v-else="">{{countDown}}秒后获取</span></div>
    <div class="reg_row"><span class="reg_left"></span><span class="tips">请填写您的真实姓名及身份证号完成实名注册</span></div>
    <div class="reg_row"><span class="reg_left" >姓名：</span><span><input type="text" v-model="userName" maxlength="5"></span><span></span></div>
    <div class="reg_row"><span class="reg_left">身份证号：</span><span><input type="text" v-model="identityNumber" maxlength="18"></span><span></span></div>
    <div class="agreement"><span class="reg_left"></span><span class="check" v-if="!agree" @click="changeAgree()"></span><img class="checked" src="../../images/checked.png" alt="" @click="changeAgree()" v-if="agree">我已阅读<span class="to_agree" @click="changePage({name:'guardianship'})">《用户服务协议》</span><span class="to_agree" @click="changePage({name:'addicted'})">《隐私保护策略》</span><span class="to_agree" @click="changePage({name:'dispute'})">《纠纷处理》</span></div>
    <div class="reg_row"><span class="reg_left"></span><span class="reg_action" @click="toReg">立即注册</span><span class="cancel_action" @click="changePage({name:'home'})">取消</span></div>

  </div>
</template>

<script>
  import {hex_md5} from '../../utils/md5.js'
  import { mapMutations } from 'vuex'
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        agree:true,
        phoneNum:"",
        appSecret : "b43f0148b81511957b28e011584ea4c73570f700784cdf7891f1c040a353baca",
        clientType:3,
        captcha:"",
        countDown:120,
        countFunction:null,
        identityNumber:"",
        userName:"",
        errDesc:{
          1007:"手机号输入有误请从新输入",
          10042:"短信验证码获取频次过高，请稍后再试。",
          10043:"短信验证码获取频次过高，请稍后再试。",
          10044:"短信验证码获取频次过高，请稍后再试。"
        }
      }
    },
    methods: {
      ...mapMutations([
        'setPage','setUser','setLoginState'
      ]),
      changeAgree(){
        this.agree = !this.agree;
      },
      sendMsg(){
        let sign =hex_md5('cstId=50110&tel='+this.phoneNum+'&templateId=1&key=230b88662d9d1dfe22625d80b1f7bc04');
        this.$axios({
          url: this.$ajaxUrls.sendMessage,
          method: 'post',
          params:{
            tel:this.phoneNum,
            cstId: 50110,
            templateId: 1,
            sign:sign
          },
          headers:{
            'Content-Type':'application/json'
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.open("发送成功,请查收");
            this.countFunction = setInterval(()=>{
              this.countDown -= 1;
              if(this.countDown === 0){
                clearInterval(this.countFunction);
                this.countDown = 120;
              }
            },1000);
          }else{
            this.open(this.errDesc[res.data.errCode])
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      open(msg='发送失败') {
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      },
      //nonce生成*位随机串
      getNonce(len, charSet){
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
      },
      sign(method,appId,nonce,timestamp,signUrl,appSec){
        var str = method + 'X-QP-AppId:'+appId+'X-QP-Nonce:'+nonce+'X-QP-Timestamp:'+timestamp+signUrl+appSec;
        var newStr = hex_md5(str).toUpperCase();
        return newStr;
      },
      getOS(){
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'ios';
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'android';
        }
      },
      reg(){
        if(this.captcha === ""){
          this.open("请输入验证码");
          return false
        }
        if(!/^\d{5}$/.test(this.captcha)){
          this.open("验证码错误，请输入正确有效的短信验证码。");
          return false
        }
        let regName =/^[\u4e00-\u9fa5]{2,4}$/;
        if(!regName.test(this.userName)){
          this.open('请输入身份证上的姓名和身份证号');
          return false;
        }
        let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(!regIdNo.test(this.identityNumber)){
          this.open('请输入身份证上的姓名和身份证号');
          return false;
        }
        if(!this.agree){
          this.open("请先阅读并接受《用户服务协议》和 《隐私政策》 《纠纷处理》");
          return false
        }
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.uc + '/uc/v1/login/phone?appId=200010&captcha='+this.captcha+'&mobilePhone='+this.phoneNum;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':200010,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',200010,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            console.log(typeof this.phoneNum);
            let account = String(this.phoneNum).slice(0,3)+"****"+String(this.phoneNum).slice(-3);
            this.setLoginState(true);
            this.saveIdentity(res.data.data.gid,res.data.data.userId);
            this.setUser(res.data.data);
            this.$alert("注册成功，当前账号为："+account+"您可使用手机号+短信验证码登录大唐官网", '注册成功', {
              confirmButtonText: '官网首页',
              callback: action => {
                this.$router.push({name:'home'});
              }
            });
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      saveIdentity(gid,userId){
        this.$axios({
          url: this.$ajaxUrls.oauth,
          params:{
            gid:gid,
            appId: 200010,
            identityNumber: this.identityNumber,
            userId:userId,
            name:this.userName
          },
          method: 'post',
        }).then((res)=>{
        }).catch((err)=>{
          console.log(err)
        })
      },
      changePage(path){
        this.$router.push(path);
      },
      toReg(){
        this.checkPhoneNum(this.reg);
      },
      toSendMsg(){
        this.checkPhoneNum(this.sendMsg)
      },
      checkPhoneNum(callback){
        if(this.phoneNum == ""){
          this.open("请输入手机号");
          return false
        }
        if(!/^1[34578]\d{9}$/.test(this.phoneNum)){
          this.open("请输入正确的手机号");
          return false
        }
        let sign =hex_md5('gameId=200010&telphone='+this.phoneNum+'&key=B1081EE774CE54FB6CAC6075009729183c6e0b8a9c15224a8228b9a98ca1531d').toUpperCase();
        this.$axios({
          url: this.$ajaxUrls.check,
          method: 'get',
          params:{
            gameId: 200010,
            sign:sign,
            telphone:this.phoneNum
          },
          headers:{
            'Content-Type':'application/json'
          }
        }).then((res)=>{
          console.log(res.data);
          if(res.data.meta.code === '6043'){
            this.open('该账号已注册，无需再次注册')
          }else{
            callback();
          }
        }).catch((err)=>{
          alert(err)
        })
      }
    },
    mounted() {

    },
    computed: mapState([
      'loginPage'
    ])
  }
</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .reg_box{width: 1340px;height:688px;margin: 0 auto;padding-top: 25px;background: url("../../images/reg_g.png") no-repeat;background-size: 100% 100%}
  .reg_title{color: #333333;font-size: 24px;text-align: center;margin-bottom: 25px;padding-top: 40px}
  .reg_left{display: inline-block;width: 100px;text-align: right;font-size: 14px}
  .agreement{font-size: 12px;margin-bottom: 20px;padding-left: 450px;margin-top: 30px}
  .check{display: inline-block;width: 16px;height: 16px;border-radius: 5px;border: 1px solid #ccd5db;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .checked{display: inline-block;width: 16px;height: 16px;border-radius: 5px;border: 1px solid #ccd5db;color: #1990FF;font-weight: bold;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .to_agree{cursor: pointer;color: #1990FF}
  .reg_row{padding-left: 450px;height: 42px;line-height: 42px;margin-bottom: 15px}
  .tips{color: #A2A2A2;font-size: 13px}
  input{height: 42px;width:260px;font-size: 14px;background-color: rgb(247,247,247);border-radius: 5px;padding-left: 10px}
  input::-webkit-input-placeholder { color: #999;}
  input::-moz-placeholder{ color: #999;}
  input:-ms-input-placeholder{ color: #999;}
  .getCode{width: 96px;height: 42px;line-height: 42px;color: #ffffff;background-color: #1990FF;border-radius: 5px;font-size: 14px;display: inline-block;text-align: center;cursor: pointer;margin-left: 10px}
  .reg_action{width:260px;  height:50px;  background:rgba(25,144,255,1);  border-radius:25px;display: inline-block;text-align: center;cursor: pointer;color: #ffffff;line-height: 50px}
  .cancel_action{width:96px;  height:50px;  background:rgba(255,255,255,1);  border-radius:25px;  border:1px solid rgba(204,213,219,1);text-align: center;cursor: pointer;line-height: 50px;display: inline-block;margin-left: 40px}
  .count_down{color: #999999;background-color: rgb(247,247,247)}
</style>
